module.exports = __webpack_public_path__ + "static/img/rectangularValve-p.d76ba75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rectangularValve-p.png
// module id = kJ5h
// module chunks = 1